import React from 'react';
import { FaGraduationCap, FaFlask, FaBook, FaGlobe } from 'react-icons/fa';
import profImage from '../assets/Jagan Mohan Reddy-Dpd3DyQo.jpg';
import './MeetProfessor.css';

export default function MeetProfessor() {
  return (
    <section className="meet-professor" id="professor">
      <div className="meet-professor__header">
        <h2 className="meet-professor__title">Meet Professor</h2>
        <div className="meet-professor__divider">
          <span className="divider-blue"></span>
          <span className="divider-orange"></span>
        </div>
      </div>

      <div className="meet-professor__container">
        <div className="professor-card">
          {/* Left Side - Image */}
          <div className="professor-card__left">
            <div className="professor-card__image-wrapper">
              <img src={profImage} alt="Prof. Dr. B. Jagan Mohan Reddy" className="professor-card__image" />
            </div>
            <a href="#research" className="professor-card__btn">
              View More Details
            </a>
          </div>

          {/* Right Side - Info */}
          <div className="professor-card__right">
            <h3 className="professor-card__name">Prof. Dr. B. Jagan Mohan Reddy</h3>
            <span className="professor-card__role">Professor & BOS Chairman</span>
            
            <p className="professor-card__bio">
              Dedicated to advancing the field of Chemistry through rigorous research, teaching, and administrative leadership. Currently serving as the Head of the Department of Chemistry at Adikavi Nannaya University with over 20 years of academic experience.
            </p>

            <div className="professor-card__skills">
              <div className="skill-bar">
                <div className="skill-bar__header">
                  <span className="skill-bar__title">Synthetic Organic Chemistry</span>
                  <span className="skill-bar__percent">98%</span>
                </div>
                <div className="skill-bar__track">
                  <div className="skill-bar__fill" style={{ width: '98%' }}></div>
                </div>
              </div>

              <div className="skill-bar">
                <div className="skill-bar__header">
                  <span className="skill-bar__title">Drug Discovery & Anticancer Agents</span>
                  <span className="skill-bar__percent">88%</span>
                </div>
                <div className="skill-bar__track">
                  <div className="skill-bar__fill" style={{ width: '88%' }}></div>
                </div>
              </div>
            </div>

            <div className="professor-card__socials">
              <a href="https://scholar.google.com/citations?user=MxYa8XQAAAAJ&hl=en" target="_blank" rel="noopener noreferrer" aria-label="Google Scholar"><FaGraduationCap /></a>
              <a href="https://orcid.org/0000-0001-9357-9610" target="_blank" rel="noopener noreferrer" aria-label="ORCID"><FaGlobe /></a>
              <a href="https://vidwan.inflibnet.ac.in/profile/653188" target="_blank" rel="noopener noreferrer" aria-label="Vidwan"><FaBook /></a>
              <a href="#contact" aria-label="Contact"><FaFlask /></a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
